import fs from 'node:fs'
import { tombstonePath } from './tombstone-path.js'

export function clearTombstone(cwd: string, scope: string): void {
  fs.rmSync(tombstonePath(cwd, scope), { force: true })
}
